<template>
  <v-select
    class="lc-dropdown"
    v-model="selectValue"
    :options="options"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="false"
    :searchable="true"
    :resetOnOptionsChange="resetOnOptionsChange"
  >
    <template v-slot:open-indicator>
      <img src="@/assets/dropdown-arrow.svg" class="vs__open-indicator" />
    </template>
  </v-select>
</template>

<script>
  export default {
    name: 'LCDropdownInput',
    props: {
      value: null,
      placeholder: String,
      options: Array,
      resetOnOptionsChange: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        selectValue: this.value
      }
    },
    watch: {
      selectValue() {
        this.$emit('input', this.selectValue);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
